import React from 'react';
import { Link } from 'react-router-dom';
import { termsContent } from '../data/termsContent';

const TermsView: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-900 text-gray-100">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="mb-6">
          <Link to="/" className="text-indigo-400 hover:text-indigo-300 text-sm">
            ← ホームに戻る
          </Link>
        </div>
        
        <div className="bg-gray-800 rounded-lg p-6 md:p-8">
          <h1 className="text-3xl font-bold mb-8 text-indigo-400">AISHA 利用規約</h1>
          
          <div className="prose prose-invert max-w-none space-y-6">
            {termsContent}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsView;